// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gKGaX","importantInfo":"styles_importantInfo__2JmrP"};